// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Nexa-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Nexa-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cormorant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Cormorant-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Cormorant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Bruney.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/GeneralSans-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/GeneralSans-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Nexa";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "Cormorant";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 700;
}
@font-face {
  font-family: "Bruney";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  font-style: normal;
  font-weight: 600;
}
@font-face {
  font-family: "GeneralSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  font-style: normal;
  font-weight: 700;
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}

body {
  font-family: GeneralSans, sans-serif;
}

.header {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media (min-width: 768px) {
  .header {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
@media (min-width: 768px) {
  .header__list {
    display: flex;
    flex-direction: row;
    padding-left: 1.5rem;
    gap: 6%;
  }
}
.header__list--brandname {
  cursor: pointer;
  list-style-type: none;
  font-family: Bruney, sans-serif;
  font-weight: 600;
  color: #847508;
  font-size: 1.2rem;
}
@media (min-width: 1280px) {
  .header__list--brandname {
    font-size: 1.4rem;
  }
}
.header__list--item {
  cursor: pointer;
  display: none;
}
@media (min-width: 768px) {
  .header__list--item {
    display: flex;
    width: 6.5rem;
    list-style-type: none;
    font-size: 1rem;
  }
  .header__list--item:hover {
    font-weight: 700;
  }
}
@media (min-width: 768px) and (min-width: 1280px) {
  .header__list--item {
    width: 8.5rem;
    font-size: 1.2rem;
  }
}

.headeractive {
  font-weight: 700;
  font-size: 1rem;
}
@media (min-width: 1280px) {
  .headeractive {
    font-size: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/partials/_typography.scss","webpack://./src/components/Header/Header.scss","webpack://./src/styles/partials/_global.scss","webpack://./src/styles/partials/_mixins.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,wBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ADCA;EACI,0BAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;ACCJ;ACzEA;;;EAGI,sBAAA;EACA,SAAA;AD2EJ;;ACzEA;EACI,oCAAA;AD4EJ;;AAlFA;EACQ,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,wCAAA;AAqFR;AEhGI;EFEJ;IAWY,iBAAA;IACA,oBAAA;EAuFV;AACF;AEtGI;EFgBI;IAEI,aAAA;IACA,mBAAA;IACA,oBAAA;IACA,OAAA;EAwFV;AACF;AAvFY;EACI,eAAA;EACA,qBAAA;EACA,+BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAyFhB;AEjHI;EFkBQ;IAQQ,iBAAA;EA2FlB;AACF;AAzFY;EACI,eAAA;EACA,aAAA;AA2FhB;AE/HI;EFkCQ;IAII,aAAA;IACA,aAAA;IACA,qBAAA;IACA,eAAA;EA6Fd;EA5Fc;IACI,gBAAA;EA8FlB;AACF;AErII;EF6BQ;IAYQ,aAAA;IACA,iBAAA;EAgGlB;AACF;;AA3FA;EACI,gBAAA;EACA,eAAA;AA8FJ;AEhJI;EFgDJ;IAIQ,iBAAA;EAgGN;AACF","sourcesContent":["@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Nexa\";\n    src: url(../../assets/fonts/Nexa-Bold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Light.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Regular.ttf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Medium.ttf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-SemiBold.ttf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"Cormorant\";\n    src: url(../../assets/fonts/Cormorant-Bold.ttf);\n    font-style: normal;\n    font-weight: 700;\n}\n@font-face{\n    font-family: \"Bruney\";\n    src: url(../../assets/fonts/Bruney.ttf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Extralight.otf);\n    font-style: normal;\n    font-weight: 300;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Light.otf);\n    font-style: normal;\n    font-weight: 400;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Regular.otf);\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Semibold.otf);\n    font-style: normal;\n    font-weight: 600;\n}\n@font-face{\n    font-family: \"GeneralSans\";\n    src: url(../../assets/fonts/GeneralSans-Bold.otf);\n    font-style: normal;\n    font-weight: 700;\n}\n","@use \"../../styles/partials/variables\" as *;\n@use \"../../styles/partials/typography\" as *;\n@use \"../../styles/partials/mixins\" as *;\n@use \"../../styles/partials/_global\" as *;\n\n.header{\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        z-index: 20;\n        background-color: #fff;\n        box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n        @include tablet-and-desktop{\n            padding-top: 1rem;\n            padding-bottom: 1rem;\n            }\n        &__list{\n            @include tablet-and-desktop{\n            display: flex;\n            flex-direction: row;\n            padding-left: 1.5rem;\n            gap: 6%;\n            }\n            &--brandname{\n                cursor: pointer;\n                list-style-type: none;\n                font-family: Bruney, sans-serif;\n                font-weight: 600;\n                color: #847508;\n                font-size: 1.2rem;\n                @include desktop{\n                    font-size: 1.4rem;\n                }\n            }\n            &--item{\n                cursor: pointer;\n                display: none;\n                @include tablet-and-desktop{\n                display: flex;\n                width: 6.5rem;\n                list-style-type: none;\n                font-size: 1rem;\n                &:hover{\n                    font-weight: 700;\n                }\n                @include desktop{\n                    width: 8.5rem;\n                    font-size: 1.2rem;\n                }\n                }\n        }\n    }\n}\n.headeractive{\n    font-weight: 700;\n    font-size: 1rem;\n    @include desktop{\n        font-size: 1.2rem;\n    }\n}","@use \"./variables\" as *;\n@use \"./typography\" as *;\n@use \"./mixins\" as *;\n\n*,\n*::before,\n*::after{\n    box-sizing: border-box;\n    margin: 0;\n}\nbody{\n    font-family: GeneralSans, sans-serif;\n}\n","@use \"./variables\" as *;\n\n@mixin tablet-and-desktop {\n    @media (min-width: $tablet-breakpoint) {\n        @content;\n    }\n}\n@mixin desktop {\n    @media (min-width: $desktop-breakpoint) {\n        @content;\n    }\n}\n\n@mixin big-mobile-screen {\n    @media (min-width: 450px) {\n        @content;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
